import React from 'react';
import {
  List,
  Grid,
  Form,
  Loader,
  Dimmer,
} from '@mairistem/composants';
import ProfilEcritureFrequent from '../../../../interfaces/pieces/mouvements/profilEcritureFrequent';
import ProfilEcriture from '../../../../interfaces/pieces/mouvements/profilEcriture';

interface ProfilEcritureListProps {
  items: ProfilEcriture[] | ProfilEcritureFrequent[];
  loading: boolean;
  onTypeChange: any;
  onSelect: any;
  type: string;
}

const ProfilEcritureList = ({
  items = [],
  loading = false,
  onTypeChange,
  onSelect,
  type = '',
}: ProfilEcritureListProps) => {
  const handleSelect = (e, data) => {
    if (onSelect) onSelect(e, data);
  };

  const handleTypeChange = (e, data) => {
    if (onTypeChange) onTypeChange(e, data);
  };

  const renderList = () => (
    <List relaxed selection>
      {
        items?.map((item) => (
          <List.Item
            key={item?.identifiant}
            onClick={(e) => handleSelect(e, item)}
          >
            <List.Content>
              <List.Header as="a">{item?.profil?.libelle ?? item?.libelle}</List.Header>
            </List.Content>
          </List.Item>
        ))
      }
    </List>
  );

  const renderLoader = () => (
    <Dimmer active inverted>
      <Loader active />
    </Dimmer>
  );

  const renderTypes = () => (
    <>
      <Form.Radio
        label="Les fréquemment utilisés"
        value="FREQUENTS"
        checked={type === 'FREQUENTS'}
        onChange={handleTypeChange}
      />
      <Form.Radio
        label="Tous"
        value="TOUS"
        checked={type === 'TOUS'}
        onChange={handleTypeChange}
      />
    </>
  );

  return (
    <Form>
      <Grid
        as={Grid}
        minWidth={0}
        divided="vertically"
      >
        <Grid.Row
          columns={1}
          style={{ paddingBottom: 0 }}
        >
          <Grid.Column style={{ margin: 0 }}>
            <Form.Group inline>
              {renderTypes()}
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          columns={1}
          style={{ paddingTop: 0 }}
        >
          <Grid.Column
            style={{
              overflowY: 'auto',
              height: 300,
              paddingRight: '1rem',
            }}
          >
            {loading ? renderLoader() : renderList()}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

export default ProfilEcritureList;
